import * as React from "react";
import { DATASOURCE_DETAILS } from "../shared/DatasourceDetails";
import { Avatar } from "antd";
import { Tooltip } from "antd";

const DataSources = ({dataSources}) => {
    const dataSourceImage = (dataSource: string) => {
        const dataSourceDetail = DATASOURCE_DETAILS.find(dataSourceDetail => dataSourceDetail.displayName === dataSource);
        return dataSourceDetail.image
    }
    return (
        <>
            {dataSources.map((dataSource: string, index: number) =>
                <Tooltip placement="bottom" title={dataSource} key={index}>
                    <Avatar shape="square"
                            size={24}
                            style={{ background: "none", border: "none" }}
                            icon={<img src={dataSourceImage(dataSource)} alt={dataSource}/>}
                    />
                </Tooltip>
            )}
        </>
    );
};

export default DataSources;
